import useMintExistingCollectible from "hooks/collectibles/useMintExistingCollectible"

import { CompletedCollectible } from "@/types/highlights"
import { useAnalytics } from "hooks/useAnalytics"

import { useEffect } from "react"

export default function useMintExistingHighlight(props: {
  highlight: CompletedCollectible
}) {
  const { track } = useAnalytics()

  const {
    write,
    data,
    error: writeError,
    prepareError,
    priceError,
    isLoading,
    isSuccess,
  } = useMintExistingCollectible(props.highlight)

  const error = writeError || priceError || prepareError

  useEffect(() => {
    if (!error || !priceError || !prepareError) return
    track("collectible highlight existing mint error", {
      highlight: props.highlight,
      error,
      priceError,
      prepareError,
    })
  }, [error, priceError, prepareError])

  useEffect(() => {
    if (!isSuccess) return
    track("collectible highlight existing mint success", {
      highlight: props.highlight,
    })
  }, [isSuccess])

  const buy = async () => {
    track("collectible  highlight existing mint triggered", {
      highlight: props.highlight,
    })

    const writeResult = write?.()

    console.log("Buying is about to get triggered!", writeResult)
  }

  console.log("useMintExistingHighlight", {
    data,
    error,
    prepareError,
    priceError,
    isLoading,
    isSuccess,
  })

  return { buy, data, error, isLoading, isSuccess }
}
